import TrackingEventsList from "../../components/Pages/Tracking/Events/List";

const TrackingEvents = () => {
  return (
    <div>
      <TrackingEventsList />
    </div>
  );
};

export default TrackingEvents;
